<template>
    <div id="modal-mail-group-change" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="d-flex mb-3">
                        <div class="text-nowrap">システム送信</div>
                        <div class="pl-3">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" v-model="can" :disabled="disableCheck" class="custom-control-input" id="customSwitch1">
                                <label class="custom-control-label" for="customSwitch1">{{this.canLable}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mb-3">
                        <div class="pt-2 text-nowrap">グループ変更</div>
                        <div class="flex-fill pl-2">
                            <select v-model.trim="groupId" class="form-control">
                                <option value="new">新規作成</option>
                                <template v-if="type == 'user'">
                                    <option v-if="item.user_group == 'none'" value="tech">技術者</option>
                                    <option v-if="item.user_group != 'none'" value="company">法人</option>
                                </template>
                                <template v-if="type == 'partner'">
                                    <option value="partner">パートナー</option>
                                </template>
                                <template v-if="getMailGroupMember.data.group_list.length > 0">
                                    <option v-for="gp in getMailGroupMember.data.group_list" :value="gp.id" :key="gp.id">{{gp.group_nm}}</option>
                                </template>
                            </select>
                        </div>
                    </div>
                    <div class="d-flex mb-3">
                        <div class="pt-2 text-nowrap" :class="{'text-muted':disableNewGroup}">グループ作成</div>
                        <div class="flex-fill pl-2">
                            <input v-model.trim="newGroupNm" :disabled="disableNewGroup" type="text" class="form-control" maxlength="20" spellcheck=false value="">
                        </div>
                    </div>
                    <div>
                        <div class="card card-body py-2 text-muted let-sapce-1 mb-2">
                            <small>
                                <template v-if="type == 'user'">
                                    <span v-if="item.email">
                                        {{item.email}}
                                    </span>
                                    <span v-else class="text-danger">メールなし(可能原因：social user)</span>
                                </template>
                                <template v-if="type == 'partner'">
                                    <span v-if="item.sales_mail">
                                        {{item.sales_mail}}
                                    </span>
                                    <span v-else class="text-danger">to未入力</span>
                                    <hr class="my-1">
                                    <span v-if="item.sales_mail_cc">
                                        {{item.sales_mail_cc}}
                                    </span>
                                    <span v-else class="text-danger">cc未入力</span>
                                </template>
                            </small>
                        </div>
                        <!--注意： div中の部分複数行で書くと表示テキストにずれが出る -->
                        <div v-if="item.note" class="card card-body py-2 break-row"><small>{{item.note}} </small></div>
                        <div v-else class="text-danger card card-body py-2"><small>備考未入力</small></div>

                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger" type="button" @click="changeMailGroup" :disabled="disableBtn">
                        保存する
                    </button>
                    <button class="btn btn-success" type="button" @click="hideThis">
                        &nbsp;&nbsp;閉じる&nbsp;&nbsp;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from 'js/event-bus'
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                type: "",
                item: {},
                can: true,
                groupId: "",
                newGroupNm: "",
            }
        },
        mounted () {
            this.mailGroupChangeBusOn()
        },
        watch: {
            getChangeMailGroupStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            disableCheck () {
                if (this.type == 'user') {
                    return this.item.email ? false : true
                }
                if (this.type == 'partner') {
                    return this.item.sales_mail ? false : true
                }
                return false
            },
            canLable () {
                return this.can ? '有効' : '無効'
            },
            disableNewGroup () {
                return this.groupId == 'new' ? false : true
            },
            disableBtn () {
                if (this.groupId == 'new') {
                    return this.newGroupNm.trim() == "" ? true : false
                }

                let default_can = this.item.email_flg == 0 ? true : false
                let can_flg = this.can == default_can ? false : true
                let group_flg = false
                if (this.groupId == this.item.email_group) {
                    group_flg = false
                }
                if (this.groupId != 'new' && this.groupId != this.item.email_group) {
                    group_flg = true
                }

                return can_flg || group_flg ? false : true
            },
            ...mapGetters(['getMailGroupMember', 'getChangeMailGroupStatus'])
        },
        methods: {
            mailGroupChangeBusOn () {
                EventBus.$on('mailGroupChange', (type, item) => {
                    this.type = type
                    this.item = item
                    this.can = item.email_flg == 0 ? true : false
                    this.groupId = item.email_group
                    this.openThis()
                })
            },
            changeMailGroup () {
                this.$store.dispatch('changeMailGroup', {
                    type: this.type,
                    targetId: this.item.id,
                    emailFlg: this.can ? '0' : '1',
                    groupId: this.groupId,
                    newGroupNm: this.newGroupNm
                })
            },
            openThis () {
                $('#modal-mail-group-change').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-mail-group-change').modal('hide')
            },
            resetThis () {
                this.type = ""
                this.item = {}
                this.can = true
                this.groupId = ""
                this.newGroupNm = ""
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .break-row
        white-space:pre-wrap
        word-wrap:break-word
</style>
